import styled from "styled-components";

export const SistemaComponenteInterno = styled.div`
  border-radius: 0.625em;
`;
